import { render } from "./page-login.vue?vue&type=template&id=99dce742&scoped=true"
import script from "./page-login.vue?vue&type=script&lang=js"
export * from "./page-login.vue?vue&type=script&lang=js"

import "./page-login.vue?vue&type=style&index=0&id=99dce742&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99dce742"]])

export default __exports__